export default {"src":"/_next/static/media/whiteArrow.69789874.svg","height":20,"width":12,"blurWidth":0,"blurHeight":0};